<template>
  <div class="border border-solid border-grey-lightest bg-white rounded mt-6">
    <table class="m-3 min-w-full max-w-full">
      <tr class="flex justify-between mr-6 pb-3 border-b border-solid border-grey-lightest content-center">
        <th class="text-grey-dark font-semibold text-base pt-1 w-2/3 break-words">{{medication.name}}</th>
        <th class="flex justify-end">
          <button @click="remove()" class="border border-solid border-grey-lightest rounded focus:outline-none text-center pt-1 px-2"><img src="../../assets/delete_red.svg" alt="delete saved medication"></button>
          <button @click="edit()" class="border border-solid border-grey-lightest rounded focus:outline-none ml-2 pt-1 px-2"><img src="../../assets/edit.svg" alt="edit saved medication"></button>
          <button @click="add()" class="border border-solid border-grey-lightest rounded focus:outline-none font-semibold text-blue px-4 py-1 ml-2">Add</button>
        </th>
      </tr>
      <tr class="flex justify-between mr-6 mt-2 font-semibold text-grey-dark">
        <th class="text-left">
          <div class="text-grey-light text-sm">Dosage</div>
          <div class="mt-1">{{medication.dose_quantity}} {{medication.dose_unit}}</div>
        </th>
        <th class="text-left">
          <div class="text-grey-light text-sm">Frequency</div>
          <div class="mt-1 text-left">{{medication.frequency}}</div>
        </th>
        <th class="border-r border-grey-lightest pr-5 text-left">
          <div class="text-grey-light text-sm">Duration</div>
          <div class="mt-1">{{`${medication.duration} ${medication.duration_unit}`}}</div>
        </th>
        <th class="flex text-grey-light text-sm items-center justify-between pr-3 justify-items-start">
          <div class="text-left leading-6 pr-4">Current<br>Medication</div>
          <input type="checkbox" @change="toggleCheckbox" v-model="medication.is_current" class="check form-checkbox h-5 w-5">
        </th>
      </tr>
    </table>
  </div>
</template>

<script>

export default {
  props: ['medication'],
  data () {
    return {
      med: this.medication
    }
  },
  methods: {
    remove () {
      this.$emit('removeSaved', this.medication.id)
    },
    edit () {
      this.$emit('editSaved', this.med)
    },
    add () {
      this.$emit('addToMedications', this.med)
    },
    toggleCheckbox () {
      let isCurrent = { is_current: this.medication.is_current }
      this.$store.dispatch('preFilledMedications/editSavedDrug', { drugId: this.med.id, isCurrent })
    }
  }
}
</script>

<style scoped>
  .check {
    border: 1px solid gray;
    background: gray;
  }
</style>


// WEBPACK FOOTER //
// src/components/Customer/SavedDrug.vue